module.exports = __webpack_public_path__ + "img/home.8f7eb765.svg";